// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2_ofE","title":"AfterBackImages_title__2MRN2","images":"AfterBackImages_images__1jFWY"};